
























































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { createApi } from "unsplash-js";
import { UnsplashImageDtoIn } from "@/services/files/types";
import { downloadUnsplashImage, getUnsplashAccessKey } from "@/services/files/fileService";
import { logError } from "@/services/logging/loggingService";
import { debounce } from "lodash";

@Component
export default class SelectStockImageModal extends Vue {
    @Prop() id!: string;
    images: Array<any> = [];
    totalImages: number = 0;
    currentPage: number = 1;
    perPage: number = 10;
    searchQuery: string = "";
    isDownloading = false;
    unsplash: any;
    // custom event name is needed because of the tinyMceEditor implementation
    // where we need to strictly define if the uploaded image is for insert or replace
    customEvent: string = "fileUploaded";

    created() {
        getUnsplashAccessKey().then(response => {
            this.unsplash = createApi({
                accessKey: response
            });
            this.fetchImages();
        });
    }

    @Watch("currentPage")
    onPropertyChanged(value: boolean, oldValue: any) {
        this.fetchImages();
    }

    fetchImages() {
        const query = this.searchQuery || "explore";
        this.unsplash.search.getPhotos({
            query: query,
            page: this.currentPage,
            perPage: this.perPage
        }).then((result: { errors: any[]; response: any; }) => {
            if (result.errors) {
                logError(`Error occurred during fetch of images from Unsplash: ${result.errors[0]}`);
            } else {
                const feed = result.response;
                const { total, results } = feed;
                this.totalImages = total;
                this.images = results;
            }
        });
    }

    searchImages() {
        this.currentPage = 1; // Reset to first page when searching
        this.fetchImages();
    }

    // debounce method
    onInput = debounce(() => {
        this.searchImages();
    }, 500);

    downloadImage(image: any) {
        this.isDownloading = true;
        downloadUnsplashImage({
            downloadLink: image.links.download_location,
            artistName: image.user.name,
            imgDescription: image.alt_description
        } as UnsplashImageDtoIn).then(response => {
            this.$emit(this.customEvent, { fileId: response.id, name: response.name, originalFileName: response.name });
            this.$bvModal.hide(this.id);
            this.isDownloading = false;
        }).catch(() => {
            this.$bvModal.hide(this.id);
            this.isDownloading = false;
        });
    }

    unsplashPageLink(url: string) {
        return `${url}?utm_source=VisiosignCloud&utm_medium=referral`;
    }

    open(eventName: string = "fileUploaded") {
        this.customEvent = eventName;
        this.$bvModal.show(this.id);
    }

    close() {
        this.$bvModal.hide(this.id);
        this.resetState();
    }

    resetState() {
        this.isDownloading = false;
        this.searchQuery = "";
        this.currentPage = 1;
    }
}
